<template>
  <footer>
    <div class="container">
      <div class="row">
        <!-- useful links -->
        <div class="col-md-3 col-sm-6 col-xs-6 footer-widget">
          <h4>Useful Links</h4>
          <ul class="row footer-links">
            <div class="col-md-6 col-sm-6 col-xs-6">
              <li><a href="/">Website Creation</a></li>
              <li><a href="/about">About Digiprod</a></li>
              <li><a href="/services">Services</a></li>
              <!-- <li><a href="#">Blog</a></li> -->
              <!-- <li><a href="#">Mobile Apps</a></li> -->
            </div>

            <div class="col-md-6 col-sm-6 col-xs-6">
              <li><a href="#">Organization</a></li>
              <li><a href="#">24/7 Support</a></li>
              <li><a href="#">Grow Right</a></li>
              <!-- <li><a href="#">Career</a></li> -->
              <!-- <li><a href="#">In Media</a></li> -->
            </div>
          </ul>
        </div>

        <!-- recent news -->
        <div class="col-md-3 col-sm-6 col-xs-6 footer-widget">
          <!-- <h4>Recent News</h4> -->

          <div class="row footer-news">
            <!-- <div class="col-md-4 col-sm-4 col-xs-6">
              <img
                src="assets/img/intro.jpg"
                class="img-responsive center-block"
                alt="recent news 1"
              />
            </div> -->
            <div class="col-md-8 col-sm-4 col-xs-6">
              <!-- <div class="row">
                <p class="text-capitalize">
                  <a href="#">
                    a clear website gives more experience to the visitors
                  </a>
                </p>
                <p class="news-date">Dec 12,2015</p>
              </div> -->
            </div>
          </div>
          <!-- /.footer-news -->

          <div class="row footer-news">
            <div class="col-md-4 col-sm-4 col-xs-6">
              <!-- <img
                src="assets/img/intro.jpg"
                class="img-responsive center-block"
                alt="recent news 2"
              /> -->
            </div>
            <div class="col-md-8 col-sm-4 col-xs-6">
              <!-- <div class="row">
                <p class="text-capitalize">
                  <a href="#">
                    a clear website gives more experience to the visitors
                  </a>
                </p>
                <p class="news-date">Dec 12,2015</p>
              </div> -->
            </div>
          </div>
          <!-- /.footer-news -->
        </div>
        <!-- /.footer-widget -->

        <!-- news-letter -->
        <div class="col-md-3 col-sm-6 col-xs-6 footer-widget">
          <h4>Newsletter</h4>

          <p>Sign up to receive updates and exclusive offers.</p>
          <div class="input-group margin-bottom-sm">
            <input
              class="form-control"
              type="text"
              placeholder="Enter your email"
            />
            <span class="input-group-addon">
              <i class="fa fa-paper-plane fa-fw"></i>
            </span>
          </div>
          <p>We respect your privacy.</p>
        </div>
        <!-- /.footer-widget -->

        <!-- about avada agency -->
        <div class="col-md-3 col-sm-6 col-xs-6 footer-widget">
          <h4>DIGIPROD</h4>

          <p>
            DIGIPROD connects people and companies to the digital age with
            automation, online presence, and accessible technology solutions.
          </p>

          <div class="footer-address">
            <p>
              +55 (11) 91234-5678 <br />
              contact@digiprod.ca
            </p>
          </div>

          <div class="row">
            <div class="col-md-12">
              <ul class="footer-share-button">
                <li>
                  <a href="#"><i class="fa fa-twitter"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-google-plus"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-facebook"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-linkedin"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-youtube"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-pinterest"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-instagram"></i></a>
                </li>
              </ul>
              <!-- /.footer-share-button -->
            </div>
          </div>
        </div>
        <!-- /.footer-widget -->
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterView",
};
</script>
